import React from "react";
import {
  Input,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Table,
  Spin,
  Tooltip,
  Space,
  // Tooltip,
} from "antd";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { useAuth } from "../Auth/Auth";
import { http } from "../Common/http";
import { ColumnType } from "antd/lib/table";
import { isNullOrSpace } from "../Common/Utils";

interface Props {
  defaultFy?: string;
  allowClear?: boolean;
  width?: number;
  value?: string;
  allSearch?: boolean;
  onChange?: (value: string) => void;
  onDataSelect?: (record?: JustmentUnitData) => void;
}

interface JustmentUnitData {
  fyJudgementUnitId: string;
  fyEntranceExam1Id: string;
  entranceExam1Name: string;
  fyEntranceExam2Id: string;
  entranceExam2Name: string;
  fyEntranceExam3Id: string;
  entranceExam3Name: string;
  fyFacultyId: string;
  facultyName: string;
  fyDepartmentId: string;
  departmentName: string;
  fyMajorId: string;
  majorName: string;
  fyCourceId: string;
  courceName: string;
  fyAttachedInformation1Id: string;
  attachedInformation1Name: string;
  fyAttachedInformation2Id: string;
  attachedInformation2Name: string;
  fyAttachedInformation3Id: string;
  attachedInformation3Name: string;
  examinationId: string;
  status: string;
}
interface PostSearchData {
  Fy: string;
  Keyword?: string;
  EntranceExam1?: string;
  EntranceExam2?: string;
  EntranceExam3?: string;
  Faculty?: string;
  Department?: string;
  Major?: string;
  Cource?: string;
  AttachedInformation1?: string;
  AttachedInformation2?: string;
  AttachedInformation3?: string;
  AllSearch?: string;
}

const pageSize = 5;

export const JudgmentUnitSelecter = ({
  defaultFy,
  width = 600,
  onChange,
  onDataSelect,
  value,
  allSearch,
}: Props) => {
  const { user, accessToken } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [fy, setFy] = React.useState(
    defaultFy ? defaultFy : user.currentYear.toString()
  );
  const [justmentUnitLabel, setJustmentUnitLabel] = React.useState("");
  // const [justmentUnitDetail, setJustmentUnitDetail] = React.useState(<></>);
  const [entranceExam1, setEntranceExam1] = React.useState("");
  const [entranceExam2, setEntranceExam2] = React.useState("");
  const [faculty, setFaculty] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [major, setMajor] = React.useState("");
  const [datas, setDatas] = React.useState<JustmentUnitData[]>([]);
  const [page, setPage] = React.useState(1);

  const initData = async () => {
    try {
      const result = await http<JustmentUnitData>({
        path: "/Master/getjustmentunit/" + value,
        method: "get",
        accessToken: accessToken,
      });
      if (result.ok && result.body) {
        setDatas([result.body]);
        onDataChange(result.body, false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (defaultFy !== fy) {
      setFy(defaultFy ? defaultFy : user.currentYear.toString());
      setJustmentUnitLabel("");
      onChange?.("");
      onDataSelect?.(undefined);
      setDatas([]);
    } else if (
      value !== undefined &&
      value != null &&
      value.length > 0 &&
      datas.length === 0
    ) {
      initData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFy, value]);
  const columns: ColumnType<JustmentUnitData>[] = [
    {
      title: <div className="table-title">No</div>,
      key: "no",
      render: (value: any, item: JustmentUnitData, index: number) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: <div className="table-title">採点ステータス</div>,
      dataIndex: "status",
      key: "status",
      render: (value: any, item: JustmentUnitData, index: number) => {
        //1：未採点、2：採点済、3：採点提出済、4：採点確定、5：合否判定中、6：合否確定
        if (item.examinationId === "00000000-0000-0000-0000-000000000000") {
          return "";
        } else {
          if (item.status === null || item.status === "1") {
            return "未採点";
          } else if (item.status === "2") {
            return "採点済";
          } else if (item.status === "3") {
            return "採点提出済";
          } else if (item.status === "4") {
            return "採点確定";
          } else if (item.status === "5") {
            return "合否判定中";
          } else if (item.status === "6") {
            return "合否確定";
          }
        }
      },
    },
    {
      title: <div className="table-title">入試制度1</div>,
      dataIndex: "entranceExam1Name",
      key: "entranceExam1Name",
    },
    {
      title: <div className="table-title">入試制度2</div>,
      dataIndex: "entranceExam2Name",
      key: "entranceExam2Name",
    },
    {
      title: <div className="table-title">入試制度3</div>,
      dataIndex: "entranceExam3Name",
      key: "entranceExam3Name",
    },
    {
      title: <div className="table-title">学部</div>,
      dataIndex: "facultyName",
      key: "facultyName",
    },
    {
      title: <div className="table-title">学科</div>,
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: <div className="table-title">専攻</div>,
      dataIndex: "majorName",
      key: "majorName",
    },
    {
      title: <div className="table-title">コース</div>,
      dataIndex: "courceName",
      key: "courceName",
    },
    {
      title: <div className="table-title">付属情報1</div>,
      dataIndex: "attachedInformation1Name",
      key: "attachedInformation1Name",
    },
    {
      title: <div className="table-title">付属情報2</div>,
      dataIndex: "attachedInformation2Name",
      key: "attachedInformation2Name",
    },
    {
      title: <div className="table-title">付属情報3</div>,
      dataIndex: "attachedInformation3Name",
      key: "attachedInformation3Name",
    },
    {
      title: "",
      key: "action",
      render: (value: any, item: JustmentUnitData, index: number) => (
        <Button
          type="dashed"
          htmlType="button"
          onClick={() => {
            onDataChange(item);
          }}
        >
          選択
        </Button>
      ),
    },
  ];

  const onDataChange = (newValue: any, needChangeData: boolean = true) => {
    const label = `${
      newValue.entranceExam1Name == null ? "" : newValue.entranceExam1Name
    } ${newValue.entranceExam2Name == null ? "" : newValue.entranceExam2Name} ${
      newValue.entranceExam3Name == null ? "" : newValue.entranceExam3Name
    } ${newValue.facultyName == null ? "" : newValue.facultyName} ${
      newValue.departmentName == null ? "" : newValue.departmentName
    } ${newValue.majorName == null ? "" : newValue.majorName} ${
      newValue.courceName == null ? "" : newValue.courceName
    } ${
      newValue.attachedInformation1Name == null
        ? ""
        : newValue.attachedInformation1Name
    } ${
      newValue.attachedInformation2Name == null
        ? ""
        : newValue.attachedInformation2Name
    } ${
      newValue.attachedInformation3Name == null
        ? ""
        : newValue.attachedInformation3Name
    }`;
    setJustmentUnitLabel(label);
    if (needChangeData) onChange?.(newValue.fyJudgementUnitId);
    onDataSelect?.(newValue);
    setVisible(false);
  };

  const onSearchClick = (event) => {
    setVisible(true);
  };

  const onFyChanged = (item: any) => {
    // console.log(`onFyChanged${item}`);
    if (item) {
      setFy(item.value);
    } else {
      setFy("");
    }
  };

  const onFinish = async (values: any) => {
    // console.log("Success:", values);
    try {
      setIsLoading(true);
      // ページ番号を確実にリセット
      setPage(1);
      const searchData: PostSearchData = {
        Fy: String(defaultFy ? fy : values.fy ? values.fy.value : null),
        Keyword: values.keyword ? values.keyword : null,
        EntranceExam1: values.entranceExam1 ? values.entranceExam1.value : null,
        EntranceExam2: values.entranceExam2 ? values.entranceExam2.value : null,
        EntranceExam3: values.entranceExam3 ? values.entranceExam3.value : null,
        Faculty: values.faculty ? values.faculty.value : null,
        Department: values.department ? values.department.value : null,
        Major: values.major ? values.major.value : null,
        Cource: values.cource ? values.cource.value : null,
        AttachedInformation1: values.attachedInformation1
          ? values.attachedInformation1.value
          : null,
        AttachedInformation2: values.attachedInformation2
          ? values.attachedInformation2.value
          : null,
        AttachedInformation3: values.attachedInformation3
          ? values.attachedInformation3.value
          : null,
        AllSearch: allSearch ? "1" : "0",
      };
      const result = await http<JustmentUnitData[], PostSearchData>({
        path: "/Master/searchjustmentunits",
        method: "post",
        body: searchData,
        accessToken: accessToken,
      });
      if (result.ok && result.body) {
        setDatas(result.body);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  return (
    <Spin spinning={isLoading}>
      <Tooltip title={justmentUnitLabel}>
        <Space size={1}>
          {/* <Input
            readOnly={true}
            value={justmentUnitLabel}
            style={{ width: width }}
            allowClear={true}
            onClick={onSearchClick}
          /> */}
          <Button
            type="default"
            style={{
              width: width,
            }}
            onClick={onSearchClick}
          >
            <span className="buttontext">
              {isNullOrSpace(justmentUnitLabel) ? "　" : justmentUnitLabel}
            </span>
          </Button>
          <Button type="default" onClick={onSearchClick}>
            <span className="buttontext">検索</span>
          </Button>
        </Space>
      </Tooltip>
      <Modal
        title="判定単位選択"
        maskClosable={false}
        centered
        visible={visible}
        // onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={1200}
        footer={null}
      >
        <Form
          colon={false}
          layout="horizontal"
          labelCol={{ span: 7 }}
          labelAlign="left"
          labelWrap={true}
          name="judgmentUnitSearchForm"
          onFinish={onFinish}
          initialValues={{ fy: { value: fy } }}
          fields={[{ name: ["fy"], value: { value: fy } }]}
        >
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={6}>
              <Form.Item label="入試年度" name="fy">
                <CommonMasterSelect
                  allowClear={false}
                  // defaultValue={fy}
                  masterType={31}
                  onChange={onFyChanged}
                  disabled={defaultFy ? true : false}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="キーワード" name="keyword">
                <Input style={{ width: 160 }} maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={6}>
              <Form.Item label="入試制度1" name="entranceExam1">
                <CommonMasterSelect
                  masterType={25}
                  width={160}
                  fy={fy}
                  onChange={(item: any) => {
                    setEntranceExam1(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="入試制度2" name="entranceExam2">
                <CommonMasterSelect
                  masterType={26}
                  width={160}
                  fy={fy}
                  fid={entranceExam1}
                  onChange={(item: any) => {
                    setEntranceExam2(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="入試制度3" name="entranceExam3">
                <CommonMasterSelect
                  masterType={27}
                  width={160}
                  fy={fy}
                  fid={entranceExam2}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={6}>
              <Form.Item label="学部" name="faculty">
                <CommonMasterSelect
                  masterType={21}
                  width={160}
                  fy={fy}
                  allowSetDefaultValue={
                    user.userTypeCode === "UNIV_GRADER" ||
                    user.userTypeCode === "UNIV_HEAD"
                  }
                  onChange={(item: any) => {
                    setFaculty(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="学科" name="department">
                <CommonMasterSelect
                  masterType={22}
                  width={160}
                  fy={fy}
                  fid={faculty}
                  allowSetDefaultValue={
                    user.departmentId.length > 0 &&
                    user.departmentId !==
                      "00000000-0000-0000-0000-000000000000" &&
                    (user.userTypeCode === "UNIV_GRADER" ||
                      user.userTypeCode === "UNIV_HEAD")
                  }
                  onChange={(item: any) => {
                    setDepartment(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="専攻" name="major">
                <CommonMasterSelect
                  masterType={23}
                  width={160}
                  fy={fy}
                  fid={department}
                  onChange={(item: any) => {
                    setMajor(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="コース" name="course">
                <CommonMasterSelect
                  masterType={24}
                  width={160}
                  fy={fy}
                  fid={major}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={6}>
              <Form.Item label="付属情報1" name="attachedInformation1">
                <CommonMasterSelect masterType={28} width={160} fy={fy} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="付属情報2" name="attachedInformation2">
                <CommonMasterSelect masterType={29} width={160} fy={fy} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="付属情報3" name="attachedInformation3">
                <CommonMasterSelect masterType={30} width={160} fy={fy} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  検索
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <Table
              bordered
              size={"small"}
              loading={isLoading}
              rowKey={(record) => record.fyJudgementUnitId}
              columns={columns}
              dataSource={datas}
              // scroll={{ y: 720 }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {}, // click row
                  onDoubleClick: (event) => {
                    onDataChange(record);
                  }, // double click row
                  onContextMenu: (event) => {}, // right button click row
                  onMouseEnter: (event) => {}, // mouse enter row
                  onMouseLeave: (event) => {}, // mouse leave row
                };
              }}
              pagination={{
                current: page, // 現在のページ番号を同期
                size: "small",
                pageSize: pageSize,
                position: ["topLeft"],
                showTotal: (total) => {
                  return (
                    <ul className="resultCount">
                      <li className="grey">
                        対象<span>{total}</span>
                      </li>
                    </ul>
                  );
                },
                onChange: (current) => setPage(current),
              }}
            />
          </Col>
        </Row>
      </Modal>
    </Spin>
  );
};
